<template>
  <div class="select-person-type">
    <div class="row">
      <div class="col-lg-6 mb-5 mb-lg-0">
        <div
          class="option"
          :class="{ selected: innerValue === 'PF', hover: hover === 'PF' }"
          @click="setRadioValue('PF')"
          @mouseover="hover = 'PF'"
          @mouseleave="hover = null"
        >
          <div class="d-flex justify-content-between">
            <h6 class="fs-14 text-dark mb-1">Pessoa física</h6>
            <input
              class="hidden-radio"
              type="radio"
              id="PF"
              v-model="innerValue"
              value="PF"
              :disabled="disabled"
            />
          </div>
          <h6 class="text-dark fs-14">Limite de saques: R$ 1.900,00/mês.</h6>
        </div>
      </div>
      <div class="col-lg-6">
        <div
          class="option"
          :class="{ selected: innerValue === 'PJ', hover: hover === 'PJ' }"
          @click="setRadioValue('PJ')"
          @mouseover="hover = 'PJ'"
          @mouseleave="hover = null"
        >
          <div class="d-flex justify-content-between">
            <h6 class="fs-14 text-dark mb-1">Pessoa jurídica</h6>
            <input
              class="hidden-radio"
              type="radio"
              id="PJ"
              v-model="innerValue"
              value="PJ"
              :disabled="disabled"
            />
          </div>
          <h6 class="text-dark fs-14">Saque SEM limitação de valor</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "PF"
    },
    disabled: Boolean
  },
  data() {
    return {
      innerValue: this.value,
      hover: null
    };
  },
  methods: {
    setRadioValue(value) {
      if (!this.disabled && this.innerValue !== value) {
        this.innerValue = value;
        this.$emit("input", value);
      }
    }
  },
  watch: {
    innerValue(newVal) {
      if (!this.disabled && newVal !== this.value) {
        this.$emit("input", newVal);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.select-person-type {
  .option {
    height: 100%;
    padding: 16px 20px 40px 20px;
    border-radius: 16px;
    border: 2px solid var(--dark-10);
    background: var(--light);
    cursor: pointer;
    transition: all 0.3s ease;

    .hidden-radio {
      visibility: hidden;
      opacity: 0;
      transition: all 0.3s ease;
    }

    .hidden-radio:checked:after {
      padding: 0px 0px 2px 0px;
      background-color: var(--blue);
      font-size: 14px;
      color: var(--light);
    }

    &.selected {
      border: 2px solid var(--blue);
    }

    &.hover {
      border: 2px solid var(--dark-20);

      &.selected {
        border: 2px solid var(--dark);
      }

      .hidden-radio {
        visibility: visible;
        opacity: 1;
      }
    }
    &.selected .hidden-radio {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
